var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from 'vue-property-decorator';
import Table from '@/common/components/Table/oldIndex.vue'; // 列表组件
import ColorText from '@/common/components/Text/ColorText.vue';
import { filterTime } from '@/common/utils/ways';
var TableList = /** @class */ (function (_super) {
    __extends(TableList, _super);
    function TableList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // data
        _this.tableColumn = [
            { prop: 'shopName', label: '项目名称', minWidth: 120 },
            { prop: 'boothName', label: '展位名称', minWidth: 120 },
            { prop: 'name', label: '活动名称', minWidth: 120 },
            { slotName: 'clueStatus', label: '状态', minWidth: 80 },
            { slotName: 'startAt', label: '活动时间', minWidth: 180 },
        ];
        _this.statusColorMap = {
            'INTENTION': 'intention',
            'PRE_LOCK': 'lock',
            'SUCCESS': 'success',
        };
        _this.clueStatus = {
            INQUIRY: '询问',
            INTENTION: '意向',
            PRE_LOCK: '预锁',
            SUCCESS: '已成交',
            CLOSED: '已关闭',
        };
        return _this;
    }
    __decorate([
        Prop({
            type: Array,
            default: function () { return []; },
        })
    ], TableList.prototype, "tableData", void 0);
    __decorate([
        Prop({
            type: Boolean,
            default: false,
        })
    ], TableList.prototype, "tableLoading", void 0);
    TableList = __decorate([
        Component({
            components: {
                Table: Table,
                ColorText: ColorText,
            },
            filters: {
                filterDateFn: function (val, format) {
                    if (format === void 0) { format = 'YYYY.MM.DD'; }
                    return filterTime(val, format);
                },
            },
        })
    ], TableList);
    return TableList;
}(Vue));
export default TableList;
